<template>
  <v-app>
  <v-main class="background">

  <v-container max-width="900" class="text-body-1">

    <h1 class="mb-6 schrift text-decoration-underline font-weight-bold">
      Ambulante und stationäre Pflege
    </h1>

    <p>
      Zwischen Versorgung, Gesprächen, Dokumentation und Zeitdruck
      muss vieles gleichzeitig funktionieren.
    </p>

    <p>
      Hygiene läuft dabei immer mit.
      Nicht als einzelner Punkt,
      sondern als Teil jedes Handgriffs.
    </p>

    <p>
      Pflege findet nah am Menschen statt.
      Direkt, oft unter wechselnden Bedingungen
      und nicht immer planbar – besonders im ambulanten Bereich.
    </p>

    <p>
      Und genau in diesem Alltag zeigt sich,
      ob Abläufe tragen
      oder nur auf dem Papier bestehen.
    </p>

    <p>
      Vieles ist eingespielt.
      Routinen funktionieren.
    </p>

    <p>
      Und trotzdem gibt es Situationen,
      in denen Unsicherheit entsteht.
    </p>

    <p>
      Nicht, weil Wissen fehlt,
      sondern weil Anforderungen und Realität
      nicht immer sauber zusammenpassen.
    </p>

    <p>&nbsp;</p>

    <p class="mt-6"><strong>Hier setzen wir an.</strong></p>

    <p>
      Nicht mit zusätzlichen Vorgaben,
      sondern mit einem Blick auf das,
      was tatsächlich passiert.
    </p>

    <p>
      Darauf bauen wir auf.
    </p>

    <p>
      Abläufe werden so gestaltet,
      dass sie unter echten Bedingungen funktionieren.
    </p>

    <p>
      Auch dann, wenn es schnell gehen muss.
      Oder wenn sich Situationen verändern.
    </p>

    <p>
      Hygiene wird dabei nicht komplizierter,
      sondern klarer.
    </p>

    <p>
      So entsteht etwas, das im Alltag trägt.
    </p>

    <p>
      Im Dienst.
      In der Einrichtung.
      Unterwegs.
    </p>

    <p>
      Wenn Abläufe verständlich sind,
      wird Sicherheit selbstverständlich.
    </p>

    <p>
      Im Handeln.
      In Entscheidungen.
      Und im Umgang mit Anforderungen von außen.
    </p>

    <p>
      Am Ende geht es nicht um Kontrolle.
    </p>

    <p>
      Sondern um ein System,
      das von den Menschen getragen wird,
      die täglich damit arbeiten.
    </p>

 

  </v-container>
  </v-main>
  </v-app>
</template>

<script>
export default {}


</script>

<script setup>



</script>

<style>
.content{
  max-width:900px;
  margin:auto;
  padding:40px 20px;
}

section{
  margin-bottom:50px;
}

p{
  line-height:1.7;
}

h1{
  margin-bottom:16px;
}

h2{
  margin-top:30px;
}

ul{
  margin-top:10px;
}

.toolbar-title {
  font-family: "Bahnschrift", serif;
  font-size: 28px;
}
</style>